import type React from "react";

type LinkTooltipProps = {
  visible: boolean;
  linkUrl: string;
  linkText: string;
  linkNewWindow: boolean;
  onChangeUrl: (value: string) => void;
  onChangeText: (value: string) => void;
  onChangeNewWindow: (value: boolean) => void;
  onSave: () => void;
  onUnlink: () => void;
  onCancel: () => void;
  stopEditorShortcutPropagation: (event: { key: string; ctrlKey?: boolean; metaKey?: boolean; stopPropagation: () => void }) => void;
  linkTooltipRef: React.RefObject<HTMLDivElement | null>;
};

export function LinkTooltip({
  visible,
  linkUrl,
  linkText,
  linkNewWindow,
  onChangeUrl,
  onChangeText,
  onChangeNewWindow,
  onSave,
  onUnlink,
  onCancel,
  stopEditorShortcutPropagation,
  linkTooltipRef,
}: LinkTooltipProps) {
  if (!visible) return null;

  return (
    <div
      ref={linkTooltipRef}
      className="eb-QuillText__link-tooltip"
      onMouseDown={(e) => e.stopPropagation()}
    >
      <label className="eb-QuillText__link-label">
        URL
        <input
          type="text"
          className="eb-QuillText__link-input"
          placeholder="https://example.com or email@example.com"
          value={linkUrl}
          onChange={(e) => onChangeUrl(e.target.value)}
          onKeyDown={(e) => {
            stopEditorShortcutPropagation(e);
            if (e.key === "Enter") {
              e.preventDefault();
              onSave();
            } else if (e.key === "Escape") {
              onCancel();
            }
          }}
          autoFocus
        />
      </label>
      <label className="eb-QuillText__link-label">
        Link Text
        <input
          type="text"
          className="eb-QuillText__link-input"
          placeholder="Link text"
          value={linkText}
          onChange={(e) => onChangeText(e.target.value)}
          onKeyDown={(e) => {
            stopEditorShortcutPropagation(e);
            if (e.key === "Escape") {
              onCancel();
            }
          }}
        />
      </label>
      <label className="eb-QuillText__link-checkbox-label">
        <input
          type="checkbox"
          checked={linkNewWindow}
          onChange={(e) => onChangeNewWindow(e.target.checked)}
        />
        Open in new window
      </label>
      <div className="eb-QuillText__link-buttons">
        <button
          type="button"
          className="eb-QuillText__link-btn eb-QuillText__link-btn--save"
          onClick={onSave}
        >
          Save
        </button>
        <button
          type="button"
          className="eb-QuillText__link-btn eb-QuillText__link-btn--unlink"
          onClick={onUnlink}
        >
          Unlink
        </button>
        <button
          type="button"
          className="eb-QuillText__link-btn eb-QuillText__link-btn--cancel"
          onClick={onCancel}
        >
          Cancel
        </button>
      </div>
    </div>
  );
}

